import { EmailResponseDto } from 'src/generated-sources/openapi/alert-service/email';

export interface AlertEmail extends EmailResponseDto {}

export function createEmptyAlertEmail(): AlertEmail {
  return {
    id: '',
    email: '',
    position: '',
    status: true,
    walletId: '',
  };
}
